export default "__VITE_ASSET__BSQQP6cT__"